import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useTicketGroups } from 'pages/store';
import DashboardFilter from './DashboardFilter';
import TicketStatusTable from './TicketStatusTable';

const TicketingDashboard = () => {
  const { fetchTicketDashboardData, ticketDashboard } = useTicketGroups()
  const [selectedSubcat, setSelectedSubcat] = useState([]);
  const [userData, setUserData] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  useEffect(() => {
    fetchTicketDashboardData({
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day'),
    });
  }, [])


  return (
    <div className='bg-white'>
      <DashboardFilter
        selectedSubcat={selectedSubcat}
        setSelectedSubcat={setSelectedSubcat}
        userData={userData}
        setUserData={setUserData}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate} />
      <TicketStatusTable
        ticketDashboard={ticketDashboard}
        fetchTicketDashboardData={fetchTicketDashboardData}
        selectedSubcat={selectedSubcat}
        userData={userData}
        startDate={startDate}
        endDate={endDate} />
    </div>
  );
};

export default TicketingDashboard;
